import { InjectionToken } from '@angular/core';
import { HasuraBaseQuery, HasuraQuery } from '@anduin/shared';

export const PENDING_HASURA_BASE_QUERY_TOKEN = new InjectionToken<HasuraBaseQuery>('PENDING_HASURA_BASE_QUERY_TOKEN');

export const PENDING_HASURA_BASE_QUERY = new HasuraBaseQuery(
  'getUnsentEmailsPending',
  'vw_unsent_email_pending',
  [
    new HasuraQuery('id'),
    new HasuraQuery('status'),
    new HasuraQuery('reason_code', null, null, 'reasonCode'),
    new HasuraQuery('created_at', null, null, 'createdAt'),
    new HasuraQuery('updated_at', null, null, 'updatedAt'),
    new HasuraQuery('dismissed_at', null, null, 'dismissedAt'),
    new HasuraQuery('resolved_at', null, null, 'resolvedAt'),
    new HasuraQuery('subject'),
    new HasuraQuery('recipient_email', null, null, 'recipient'),
    new HasuraQuery('recipient_cc', null, null, 'recipientCc'),
    new HasuraQuery('recipient_bcc', null, null, 'recipientBcc'),
    new HasuraQuery('all_recipients', null, null, 'allRecipients'),
  ],
);
